/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingGovIcon16Solid = forwardRef('BuildingGovIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.599 5.18 6.853.804a2 2 0 0 1 2.294 0L15.4 5.18c.801.56.404 1.819-.573 1.819H13.05v5.225h.7a1.375 1.375 0 1 1 0 2.75H2.25a1.375 1.375 0 1 1 0-2.75h.7V7H1.172C.195 7-.202 5.741.6 5.18ZM5.05 7v5.225h1.9V7h-1.9Zm4 0v5.225h1.9V7h-1.9Z" })));
});
